import { usePageJsonLd } from './usePageJsonLd';
import type { PageSeoData } from './useJsonLdShared';

const ORGANIZATION_NAME = 'Too Good To Go';

interface HomeJsonLdOptions {
  pageData: PageSeoData;
}

/**
 * Builds and injects JSON-LD structured data for the homepage.
 * Organization is identical on all locales (global entity).
 * areaServed belongs only in MobileApplication with localized country name + Wikidata.
 * Uses stable IDs: #organization, #website-{locale}, #webpage, #app-ios-{locale}, #app-android-{locale}.
 */
export function useHomeJsonLd(options: HomeJsonLdOptions) {
  usePageJsonLd({
    pageData: options.pageData,
    isCurrentPage: path =>
      path === '/' ||
      path === '' ||
      path === '/index' ||
      !!path.match(/^\/[a-z]{2}(-[a-z]{2})?\/?$/),
    pageType: 'WebPage',
    defaultTitle: ORGANIZATION_NAME,
    pagePath: '/',
    scriptKey: 'home-jsonld',
    isHomePage: true,
  });
}
